import React, { useState } from 'react'
import {
    Modal,
    Action,
    Center,
    List,
    Carta,
    CloseButton,
    DeleteButton,
    BottonText,
    FullCarta,
    FullDiv,
    FullTapa,
    DorsalImage
} from "./styles"
import { Typography, Modal as ModalAnt, Form, Space, Button } from 'antd'
import { CloseOutlined, DeleteOutlined } from '@ant-design/icons';
const { Title } = Typography;
import pokeCartaTapa from "../../../../../Assets/tapa.png"
import { useEliminarEquipo } from '../../../../../Hooks/Player';


export const ModalDetail = ({ data, setShow, refetch }) => {
    const [showCard, setShowCard] = useState([false, ""])
    const [modalDelete, setModalDelete] = useState(false);

    const apiEliminarEquipo = useEliminarEquipo();

    return (
        <Modal>
            <Action>
                <Title style={{fontFamily: "POKEFONT" }} level={2} >{data.nombre.toUpperCase()}</Title>
            </Action>
            <Center>
                <List>

                <DorsalImage src={pokeCartaTapa} alt="Dorsal" />
                {
                    data.poke.map((item,index) => {
                        const position = {
                            left: 100 * index, // Ajusta el espaciado horizontal
                            top: 0, // Ajusta el valor de `top` si deseas que se dispongan en otras filas
                          };
                        return (
                            <Carta 
                                src={item.imagPokemon} 
                                key={item.idPokemon} 
                                onClick={() => setShowCard([!showCard[0], item.imagPokemon])} 
                                alt={`Card ${index}`} style={{ animationDelay: `${index * 0.1}s` }}
                                position={position}
                            />
                        )
                    })
                }
                </List>
                
                <BottonText>
                    <Title style={{fontFamily: "POKEFONT" }} level={5} >{`POTENCIA EQUIPO: ${data.potenciaTotal}`}</Title>
                </BottonText>
            </Center>

            <CloseButton onClick={() => setShow(false)}>
                <Title style={{fontWeight: "bold"}} level={5} ><CloseOutlined /></Title>
            </CloseButton>

            <DeleteButton>
                <Title style={{fontWeight: "bold", color: "white"}} level={5} onClick={() => setModalDelete(true)} ><DeleteOutlined /></Title>
            </DeleteButton>

            {
                showCard[0] && <FocusCarta setShowCard={setShowCard} showCard={showCard} />

            }
            <ModalAnt
                title="¿ELIMINAR EQUIPO?"
                open={modalDelete}
                footer={null}
                onCancel={() => setModalDelete(false)}
            >
                <Form
                name="validateOnly"
                layout="vertical"
                autoComplete="off"
                onFinish={async (e) => {
                    const deleteEquipo = {
                        idEquipo: data.idEquipo,
                    };
                    await apiEliminarEquipo.mutateAsync(deleteEquipo);
                    setShow(false)
                    refetch()
                }}
                >
                    <Form.Item>
                        <Space style={{ marginTop: "20px"}}>
                            <Button htmlType="submit" type="primary">
                                Aceptar
                            </Button>
                            <Button htmlType="reset" onClick={() => setModalDelete(false)}>Cerrar</Button>
                        </Space>
                    </Form.Item>
                </Form>
            </ModalAnt>
        </Modal>

    )
}

export const FocusCarta = ({setShowCard, showCard, fixed = "false"}) => {
    return (
        <FullDiv onClick={() => setShowCard([!showCard[0], ""])}>
            <FullCarta src={showCard[1]} onClick={() => setShowCard([!showCard[0], ""])} fixed={fixed}/>
            <FullTapa src={pokeCartaTapa} onClick={() => setShowCard([!showCard[0], ""])} fixed={fixed}/>
        </FullDiv>
    )
}
